import {SupportedLocale} from '@/initializers/i18next';
import {BaseValue, CustomValue} from '@/model/types';
import {AllocationAccount} from '@/repositories/beneva-api/endpoints/allocations';

export const ignoreValuesWithIdIn = (idsToIgnore: string[]) => (value: CustomValue) => !idsToIgnore.includes(value.id);

export const keepOnlyActiveValues = (value: CustomValue) => {
  const startDate = value.properties.DtDb as string | undefined;
  const endDate = value.properties.DtFi as string | undefined;
  if (!startDate || !endDate) return false;

  const currentTime = new Date().getTime();
  const startTime = new Date(startDate).getTime();
  const endTime = new Date(endDate).getTime();

  return startTime <= currentTime && endTime > currentTime;
};

type Option = {
  label: string;
  value: string;
};

export const mapValueToOptions =
  (locale: SupportedLocale) =>
  ({value, id}: BaseValue | CustomValue): Option => {
    const label =
      '$template' in value
        ? typeof value.$template === 'string'
          ? value.$template
          : value.$template[locale]
        : value[locale];

    return {value: id, label};
  };

export const sortLabelAsc = (a: Option, b: Option) => a.label.localeCompare(b.label);

export const computeAmountSum = (accounts: AllocationAccount[]) => {
  return accounts.reduce((memo, account) => memo + (account.amount ?? 0), 0);
};
